import { PropTypes } from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { SCButton, SCInput, SCModal, SCModalBody } from 'rollup-allspark';
import { isFunction, isNumber } from '../../../utils';
import { updateEntity } from '../actions';
import { makeSelectProperty } from '../selector';

const Vat = ({
  isOpen = false,
  onClose = () => {},
  updateField = () => {},
  vatAmount,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (isOpen) {
      ref.current.showModal();
    } else {
      ref.current.closeModal();
    }
  }, [isOpen]);

  const onModalClose = () => {
    if (isFunction(onClose)) {
      onClose();
    }
  };

  const onConfirm = () => {
    updateField({
      vat: vatAmount,
    });

    onModalClose();
  };

  const body = (
    <SCModalBody>
      <div className="flex flex-col gap-y-4 normal-case">
        <div className="text-base font-medium text-black">VAT Amount</div>
        <SCInput
          type="number"
          inputClass="border rounded-lg scam-business-name"
          value={vatAmount}
          handleChange={e =>
            updateField({ vatAmount: parseFloat(e.target.value) || 0 })
          }
          hasError={!isNumber(vatAmount)}
          hint={!isNumber(vatAmount) ? 'Please enter a valid VAT Amount' : ''}
        />
        <div className="pt-8 flex gap-x-4 justify-end">
          <SCButton variant="danger-outline" action={onModalClose}>
            Cancel
          </SCButton>
          <SCButton action={onConfirm}>Confirm</SCButton>
        </div>
      </div>
    </SCModalBody>
  );

  return (
    <SCModal
      ref={ref}
      variant="white"
      body={body}
      size="lg"
      onModalClose={onModalClose}
    />
  );
};

Vat.propTypes = {
  isOpen: PropTypes.bool,
  vatAmount: PropTypes.number,
  onClose: PropTypes.func,
  updateField: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  vatAmount: makeSelectProperty('vatAmount'),
});

const mapDispatchToProps = dispatch => ({
  updateField: val => dispatch(updateEntity(val)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Vat);
